import {
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  showNotification,
  NOTIFICATION_TYPE,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { ListWrapper, PlaceholdersItem, PlaceholdersWrapper } from './placeholder-list.styles';
import { EMAIL_TEMPLATE_PLACEHOLDERS } from './placeholder-list.constants';

const PLACEHOLDERS_LIST = Object.values(EMAIL_TEMPLATE_PLACEHOLDERS).map(
  placeholder => `{{${placeholder}}}`
);

const PlaceholderList = () => {
  const { t } = useTranslation(['common', 'settings']);

  const handleCopy = (item: string) => () => {
    navigator.clipboard.writeText(item);
    showNotification({
      type: NOTIFICATION_TYPE.success,
      message: 'Copied',
    });
  };

  const parsePlaceholders = (str: string) => {
    const cleanedInput = str.replace(/{{|}}/g, '');
    return t(`settings:documents.placeholderList.${cleanedInput}`);
  };

  return (
    <ListWrapper>
        <Typography size={'medium'} weight={'bold'}>
          {t('settings:documents.buttons.placeholderList')}
        </Typography>
      <PlaceholdersWrapper>
        {PLACEHOLDERS_LIST.map(placeholder => (
          <PlaceholdersItem key={placeholder}>
            <span>{parsePlaceholders(placeholder)}</span>
            <div>
              {placeholder}
              <button onClick={handleCopy(placeholder)} aria-label={placeholder}>
                <Icon
                  icon={ICONS.copySolid}
                  color={PLATFORM_THEME_COLORS.grayVariations.murky}
                  size={16}
                  rightMargin={false}
                />
              </button>
            </div>
          </PlaceholdersItem>
        ))}
      </PlaceholdersWrapper>
    </ListWrapper>
  );
};

export default PlaceholderList;
